module.exports = __webpack_public_path__ + "img/sun-setting-02.e9e11b36.svg";